import React from "react";
import amaxLogo from "../../images/amaxLogo.png";
import { Link } from "react-router-dom";
import { LogoCenter } from "../../component/LogoCenter";

export const SignUpInterFace = () => {
  return (
    <div className={`p-[20px] bg-black h-dvh overflow-hidden `}>
      <div className="w-full max-w-2xl mx-auto h-full flex flex-col justify-between items-center gap-[160px] overflow-y-auto">
        <LogoCenter />
        <div className="w-full flex flex-col gap-8">
          <div className="flex flex-col gap-[15px]">
            <p className="text-white text-[26px] leading-[108%] font-normal">
              Sign in <br />
              <span className="font-bold text-[40px] leading-[95%]">
                ATHLETE.
              </span>
            </p>
            <form action="" className="flex flex-col gap-[15px]">
              <input
                type="email"
                className="border border-white rounded-[50px] bg-transparent text-white text-lg !leading-none p-[16px] font-normal placeholder:text-[#5d5d5d]"
                placeholder="Email"
              />
              <input
                type="password"
                className="border border-white rounded-[50px] bg-transparent text-white text-lg !leading-none p-[16px] font-normal placeholder:text-[#5d5d5d]"
                placeholder="Password"
              />
            </form>
            <Link to="/signupinfo">
              <button className="text-base font-semibold w-full bg-white transition-all duration-300 rounded-[75px] border border-white flex justify-center items-center px-2 py-[18px] hover:text-white hover:bg-transparent">
                SIGN IN
              </button>
            </Link>
            <Link
              to="/"
              className="text-white hover:text-[#5d5d5d] transition-all duration-300 text-sm font-normal text-end inline-block w-fit ml-auto"
            >
              Forgot password?
            </Link>
          </div>
          <div className="flex flex-col gap-[15px]">
            <Link
              to="/"
              className="text-white hover:text-[#5d5d5d] transition-all duration-300 text-sm font-normal text-start inline-block w-fit"
            >
              Not a Member?
            </Link>
            <Link to="/signupinfo">
              <button className="text-base text-white font-semibold w-full transition-all duration-300 rounded-[75px] hover:bg-white hover:text-black border border-white flex justify-center items-center px-2 py-[18px]">
                JOIN US
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
